<div [@routeAnimation]="getRouteAnimationData()">
    <router-outlet />
</div>
